import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

// Get dropdown options (public endpoint)
export const getDropdownOptions = async () => {
  try {
    const response = await axios.get(`${API_URL}/settings/dropdown-options`);
    return response.data;
  } catch (error) {
    console.error('Error fetching dropdown options:', error);
    // Return default options if API fails
    return {
      collection: ['Roz Roz', 'Kuch Roz'],
      productType: ['Top', 'Skirt', 'Dress', 'Bags', 'Tie', 'Stole', 'Bandana', 'Pants', 'Kurti', 'Shirt', 'Shrug', 'Jacket', 'Shorts', 'Bottom'],
      storeCategories: ['Tops', 'Bottoms', 'Dresses', 'Jackets', 'Accessories'],
      color: ['Black', 'Brown', 'Blue', 'Green', 'Indigo', 'Multicolour', 'Off White', 'Orange', 'Red', 'Brick Red', 'Teal', 'White', 'Yellow'],
      fabricType: ['Modal', '60-60 Cambric Cotton', 'Mul Cotton', 'Cotton Blend Chanderi Silk', 'Maheswari silk', 'Cotton Blend linen'],
      fabricPrint: ['Daboo', 'Bagru', 'Hand Block', 'Kalamkari', 'Ajrak', 'Tie & Dye', 'Patch Work', 'Kantha', 'Ikat', 'Solid dye'],
      fabricPattern: ['Bandhani', 'Floral', 'Plain', 'Motif', 'Stripes', 'All over', 'Animal', 'Lahriya'],
      length: ['Cropped', 'Standard', 'Short', 'Long', 'Mini', 'Knee', 'Midi', 'Maxi'],
      sleeves: ['Sleeveless', 'Full Sleeves', '3/4th Sleeves', 'Half Sleeves'],
      closure: ['Touch Buttons', 'Buttons', 'Hooks', 'String', 'Zip', 'Elastic']
    };
  }
};

// Update dropdown options (admin only)
export const updateDropdownOptions = async (dropdownOptions) => {
  const token = localStorage.getItem('token');
  const response = await axios.put(
    `${API_URL}/settings/dropdown-options`,
    { dropdownOptions },
    {
      headers: {
        Authorization: `Bearer ${token}`
      }
    }
  );
  return response.data;
};
